var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckAttendance = function SvgIconCheckAttendance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#429D15",
    d: "M24 4C12.98 4 4 12.98 4 24s8.98 20 20 20 20-8.98 20-20S35.02 4 24 4m9.56 15.4L22.22 30.74a1.5 1.5 0 0 1-2.12 0l-5.66-5.66c-.58-.58-.58-1.54 0-2.12s1.54-.58 2.12 0l4.6 4.6 10.28-10.28c.58-.58 1.54-.58 2.12 0s.58 1.52 0 2.12"
  })));
};
export default SvgIconCheckAttendance;